import React from "react";
import SectionHeader from "../../ui/SectionHeader";
// New ambassador logos
import sfimar from "../../../images/sponsors/sfimar-logo.png";
import atlasSkilltech from "../../../images/sponsors/atlas-skilltech-logo.jpeg";
import mannFoundation from "../../../images/sponsors/mann-foundation-logo.png";
import rotaryParleshwar from "../../../images/sponsors/rotary-parleshwar-logo.png";
import muso from "../../../images/sponsors/muso-logo.png";
import stPauls from "../../../images/sponsors/stpauls-logo.png";
// Existing partner logos
import connectofr from "../../../images/sponsors/connectofr.png";
import DAN from "../../../images/sponsors/DAN.png";
import django from "../../../images/sponsors/django.png";
import Drona from "../../../images/sponsors/Drona-Foundation.png";
import Holy from "../../../images/sponsors/Holy-Cross-Kurla.png";
import Jamnabai from "../../../images/sponsors/Jamnabai-Narsee-School-black.png";
import kc from "../../../images/sponsors/kc-college-1.png";
import Kohinoor from "../../../images/sponsors/Kohinoor-Business-School_1.png";
import Life_Vest_Inside_Logo_transparent from "../../../images/sponsors/Life_Vest_Inside_Logo_transparent.png";
import Little from "../../../images/sponsors/Little-Sisters-of-the-Poor.png";
import MAD from "../../../images/sponsors/MAD_LOGO_11-4-17-1.png";
import mcubed from "../../../images/sponsors/MCubed-Library.png";
import roti from "../../../images/sponsors/Mumbai-Roti-Bank.png";
import NSPA from "../../../images/sponsors/NSPA.png";
import parleshwar from "../../../images/sponsors/parleshwar-1.png";
import rotary from "../../../images/sponsors/Rotary-Club.png";
import schbang from "../../../images/sponsors/schbang.png";
import smash from "../../../images/sponsors/Smaaash.png";
import sparsha from "../../../images/sponsors/Sparsha-Charitable-Trust_transparency.png";
import andrews from "../../../images/sponsors/St.-Andrews-college.png";
import TitleWaves from "../../../images/sponsors/Title-Waves.png";
import toiing from "../../../images/sponsors/toiing.png";
import trilogy from "../../../images/sponsors/Trilogy.png";
import villa from "../../../images/sponsors/Villa-Teresa-school.png";
import sporting from "../../../images/sponsors/WhatsApp-Image-2020-03-15-at-8.19.45-AM-1.png";
import projectMumbai from "../../../images/sponsors/WhatsApp-Image-2021-02-15-at-22.54.58-1.png";
import society from "../../../images/sponsors/WhatsApp-Image-2021-02-15-at-22.54.58-2.png";

const logos = [
  // New ambassador logos first
  sfimar, atlasSkilltech, mannFoundation, rotaryParleshwar, muso, stPauls,
  // Existing logos
  connectofr, DAN, Holy, django, Drona, Holy, Jamnabai, kc, Kohinoor,
  Life_Vest_Inside_Logo_transparent, Little, MAD, mcubed, roti, NSPA,
  parleshwar, rotary, schbang, smash, sparsha, andrews, TitleWaves,
  toiing, trilogy, villa, sporting, projectMumbai, society,
];

const Partners = () => (
  <section className="ku-section bg-ku-cream overflow-hidden">
    <div className="ku-container mb-8">
      <SectionHeader title="Our Kindness Ambassadors" />
    </div>
    <div className="relative">
      <div className="flex animate-[scroll_40s_linear_infinite] w-max gap-12 hover:[animation-play-state:paused]">
        {[...logos, ...logos].map((src, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-36 h-36 md:w-44 md:h-44 ku-glass rounded-ku flex items-center justify-center p-4 grayscale hover:grayscale-0 transition-all duration-300"
          >
            <img src={src} alt="" className="max-w-full max-h-full object-contain" />
          </div>
        ))}
      </div>
    </div>
    <style>{`
      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `}</style>
  </section>
);

export default Partners;
